import { call, put, takeEvery, fork } from 'redux-saga/effects';
import { REQUEST } from 'redux-config/reduxHelpers';
import { GET_ACTIVE_ANNOUNCEMENT, getActiveAnnouncement } from './actions';
import { getActiveAnnouncement as apiGetActiveAnnouncement } from '../_api';

function* handleGetActiveAnnouncement() {
  try {
    const { data } = yield call(apiGetActiveAnnouncement);
    // API 返回的是数组，取第一个元素
    const announcement = data && data.length > 0 ? data[0] : { state: 0, content: '' };
    yield put(getActiveAnnouncement.success(announcement));
  } catch (error) {
    yield put(getActiveAnnouncement.failure(error));
  }
}

function* getActiveAnnouncementWatcher() {
  yield takeEvery(GET_ACTIVE_ANNOUNCEMENT[REQUEST], handleGetActiveAnnouncement);
}

export default [fork(getActiveAnnouncementWatcher)];
